import { toast } from "sonner";
import { api, errMsg, fmt } from "../lib/api";
import { useFetch } from "../lib/useFetch";
import { Panel, Spinner } from "./common";
import { Switch } from "./ui/switch";

const pct = (v) => (v == null ? "—" : `${v}%`);
const mv = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${fmt(v, 2)}%`);
const NAMES = { all: "All BUY signals", allowed: "Index in uptrend (kept)", blocked: "Index not in uptrend (blocked)" };

const Indexes = ({ list }) => (
  <div className="mb-3 flex flex-wrap gap-2" data-testid="index-now">
    {list.map((x) => (
      <span key={x.exchange} data-testid={`index-now-${x.exchange.toLowerCase()}`} className={`rounded-sm border px-2 py-1 text-[11px] ${x.up ? "border-emerald-300 bg-emerald-50 text-emerald-800" : "border-red-200 bg-red-50 text-red-700"}`}>
        {x.name}: {x.up ? "uptrend" : x.up === false ? "not uptrend" : "no data"} <span className="mono opacity-70">({x.close})</span>
      </span>))}
  </div>
);

export const IndexFilter = () => {
  const { data, reload } = useFetch("/index-filter/backtest");
  const toggle = async (v) => { try { await api.put("/settings", { index_filter_enabled: v }); toast.success(v ? "Index filter ON" : "Index filter OFF"); reload(); } catch (e) { toast.error(errMsg(e)); } };
  const s = data?.summary;
  const better = s && s.allowed.hit_pct != null && s.all.hit_pct != null && s.allowed.hit_pct > s.all.hit_pct;
  return (
    <Panel title="Market index filter · 30-day test" className="mb-3" testid="index-filter-panel">
      {!data ? <Spinner /> : (
        <>
          <Indexes list={data.indexes_now} />
          <div className="custom-scrollbar overflow-x-auto"><table className="tbl w-full" data-testid="index-filter-summary"><thead><tr><th>Group</th><th>Signals</th><th>Hit</th><th>Avg move</th></tr></thead>
            <tbody>{["all", "allowed", "blocked"].map((k) => (
              <tr key={k} data-testid={`index-filter-${k}`}><td>{NAMES[k]}</td><td className="mono">{s[k].count}</td><td className="mono font-bold" data-testid={`index-filter-${k}-hit`}>{pct(s[k].hit_pct)}</td><td className="mono">{mv(s[k].avg_move_pct)}</td></tr>))}
            </tbody></table></div>
          <div className="custom-scrollbar mt-2 overflow-x-auto"><table className="tbl w-full" data-testid="index-filter-markets"><thead><tr><th>Market</th><th>All BUY</th><th>Hit</th><th>Kept</th><th>Hit kept</th></tr></thead>
            <tbody>{Object.entries(data.markets).map(([m, x]) => (
              <tr key={m} data-testid={`index-filter-market-${m.toLowerCase()}`}><td className="mono">{m}</td><td className="mono">{x.all.count}</td><td className="mono">{pct(x.all.hit_pct)}</td><td className="mono">{x.allowed.count}</td><td className="mono font-bold">{pct(x.allowed.hit_pct)}</td></tr>))}
            </tbody></table></div>
          <div className={`mt-2 rounded-sm border px-3 py-2 text-[11px] ${better ? "border-emerald-300 bg-emerald-50 text-emerald-800" : "border-amber-300 bg-amber-50 text-amber-800"}`} data-testid="index-filter-verdict">
            {better ? `Signals kept by the filter hit ${s.allowed.hit_pct}% vs ${s.all.hit_pct}% for all - the filter helped in this test.`
              : `Signals kept by the filter hit ${pct(s.allowed.hit_pct)} vs ${pct(s.all.hit_pct)} for all - the filter did NOT improve results overall in this test.`}
            {" "}It would have kept {s.allowed.count} of {s.all.count} BUY signals. Small sample; past results do not guarantee future results.
          </div>
          <div className="mt-3 flex items-center gap-2 text-xs">
            <Switch checked={!!data.enabled} onCheckedChange={toggle} data-testid="index-filter-switch" />
            <span data-testid="index-filter-state">{data.enabled ? "Aktif: BUY only when that market's index is in a daily uptrend" : "Tidak aktif: BUY signals ignore the market index"}</span>
          </div>
          <p className="mt-1 text-[10px] text-slate-500">{data.rule}</p>
        </>
      )}
    </Panel>
  );
};
